<div class="ajax-loading"><div class="loading-icon"></div></div>
<section class="page-title">
    <h1>Roles & Permission</h1>
    <div class="employee-code">
        <button *hasPermission="['roles.write']"  mat-raised-button mat-raised-button color="primary" class="oms-btn pull-right" (click)="openRoleDialog(roleModel)"> Add Role </button>
    </div>
</section>
<mat-card class="card-white mb-4 p-0 filter-section">
    <mat-card-title class="mb-0">
        <div class="card-white-title mb-0 cursor-pointer" [class.advanceSearchFilter]="isAdvanceSearchFilter" (click)="onDisplayFilter(null)">
            <div class="card-user-name"> <img src="./assets/images/icon-filter.svg" alt=""> Filter</div>
            <div class="office-hours">
                <a class="box-arrow" (click)="onDisplayFilter($event)" href="javascript:void(0);"></a>
            </div>
        </div>
    </mat-card-title>
    <mat-card-content [hidden]="!isAdvanceSearchFilter">
        <div class="example-form">
            <ul class="filter-list">
                <li>
                    <div class="form-group">
                        <mat-label>Keyword</mat-label>
                        <mat-form-field class="example-full-width">
                            <input matInput [(ngModel)]="filterKey" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                            <button *ngIf="filterKey" matSuffix mat-icon-button aria-label="Clear" (click)="filterKey='';applyFilter('')">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </li>
            </ul>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="card-white matcardheight">
    <mat-card-content>
        <div *ngIf="sortedRoleList.length > 0" class="stiky-table-container ps-table">
            <!-- <table class="list-table" mat-table matSort (matSortChange)="sortRoles($event)" matSortActive="name" 
                    matSortDirection="asc" [matSortDisableClear]="true" [dataSource]="dataSource"> -->
            <table class="list-table" mat-table matSort (matSortChange)="sortRoles($event)" [matSortDisableClear]="true" [dataSource]="dataSource">
                <ng-container matColumnDef="name">
                    <th mat-header-cell mat-sort-header="name" *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.name }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="description">
                    <th mat-header-cell mat-sort-header="description" *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.description}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action" *hasPermission="['roles.write']">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element" >
                        <ul class="action-items" [hidden]="element.name?.toLowerCase() === 'owner'">
                            <li class="view-link">
                                <a (click)="openRoleDialog(element)" class="me-3 pt-1" href="javascript:void(0)" title="Edit Role"><i class="fa fa-pencil"></i></a>
                                <a [routerLink]="['/roleclaim']" [queryParams]="{roleId:element.id}" href="javascript:void(0)" title="Manage Claims"><i class="material-icons">how_to_reg</i></a>
                            </li>
                        </ul>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <div *ngIf="dataSource.filteredData.length == 0" class="no-record-found text-center p-3">No record found.</div>
        <mat-paginator #paginator [pageSize]="pageSize" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>
    </mat-card-content>
</mat-card>